import {
  CallListItem,
  CallListItemAddResult,
  CallListItemEditResult,
  CallListItemRemoveResult,
  ContactPhoneNumber,
  ContactsService,
  Core,
  isCallListItemAddResult,
  isCallListItemEditResult,
  isCallListItemRemoveResult,
  isCallListGetResult,
  Call,
} from "@sorenson-eng/videophone-core-services";
import { SorensonContactsService } from "./SorensonContactsService";

export class SorensonContactsProvider implements ContactsService {
  contacts?: CallListItem[];

  async fetchContacts(type: string): Promise<SorensonContactsService> {
    let requestBody = {
      CallListGet: {
        CallList: {
          $: {
            Type: type,
            BaseIndex: 0,
            Count: 500,
            SortField: "Name",
            SortDir: "ASC",
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListGetResult(coreResponse)) {
        return Promise.reject(
          "Call List Get (Contacts): error parsing response"
        );
      }

      let serviceResponse = new SorensonContactsService();
      serviceResponse.contacts = new Array<CallListItem>();

      if (coreResponse.CallListGetResult.CallList.$.Count > 0) {
        const callList = coreResponse.CallListGetResult.CallList
          .CallListItem as CallListItem | CallListItem[];
        if (Array.isArray(callList)) {
          serviceResponse.contacts.push(...callList);
        } else {
          serviceResponse.contacts.push(callList);
        }
      }

      return Promise.resolve(serviceResponse);
    } catch (error) {
      throw error;
    }
  }

  async addContact(
    item: CallListItem,
    contactPhoneNumbers: ContactPhoneNumber[],
    type: string
  ): Promise<CallListItem[]> {
    let requestBody = {
      CallListItemAdd: {
        CallList: {
          $: {
            Type: type,
          },
          CallListItem: {
            Name: item.Name,
            CompanyName: item.CompanyName,
            ContactPhoneNumberList: {
              ContactPhoneNumber: contactPhoneNumbers.map(
                (contactPhoneNumber) => ({
                  ContactPhoneNumber: contactPhoneNumber,
                })
              ),
            },
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListItemAddResult(coreResponse)) {
        return Promise.reject(
          "Call List Add (Contacts): error parsing response"
        );
      }

      let addResponse = coreResponse as CallListItemAddResult;

      if (addResponse.CallListItemAddResult.$.Result === "OK") {
        return Promise.resolve([
          (coreResponse.CallListItemAddResult as any).CallList,
        ]);
      }
    } catch (error) {
      throw error;
    }

    return Promise.reject("Error in contacts add response");
  }

  async deleteContact(
    { ContactPhoneNumberList, ItemId }: CallListItem,
    type: string
  ): Promise<boolean> {
    let requestBody = {
      CallListItemRemove: {
        CallList: {
          $: {
            Type: type,
          },
          CallListItem: {
            ItemId,
            ContactPhoneNumberList,
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListItemRemoveResult(coreResponse)) {
        return Promise.reject(
          "Call List Delete (Contact): error parsing response"
        );
      }

      let deleteResponse = coreResponse as CallListItemRemoveResult;

      if (deleteResponse.CallListItemRemoveResult.$.Result === "OK") {
        return true;
      }
    } catch (error) {
      throw error;
    }

    return Promise.reject("Error in contact delete response");
  }

  async updateContact(
    { ContactPhoneNumberList, ItemId, Name, CompanyName }: CallListItem,
    type: string
  ): Promise<CallListItem[]> {
    let requestBody = {
      CallListItemEdit: {
        CallList: {
          $: {
            Type: type,
          },
          CallListItem: {
            ItemId,
            Name,
            CompanyName,
            ContactPhoneNumberList,
          },
        },
      },
    };

    try {
      const coreResponse = await Core.getInstance().coreRequest(requestBody);

      if (!isCallListItemEditResult(coreResponse)) {
        return Promise.reject("Contact edit: error parsing response");
      }

      let editResponse = coreResponse as CallListItemEditResult;

      if (editResponse.CallListItemEditResult.$.Result === "OK") {
        return Promise.resolve([
          (coreResponse.CallListItemEditResult as any).CallList,
        ]);
      }
    } catch (error) {
      throw error;
    }

    return Promise.reject("Error in contact edit response");
  }
}
